import { render, staticRenderFns } from "./TeacherTraining.vue?vue&type=template&id=1386a618&scoped=true"
import script from "./TeacherTraining.vue?vue&type=script&lang=js"
export * from "./TeacherTraining.vue?vue&type=script&lang=js"
import style0 from "./TeacherTraining.vue?vue&type=style&index=0&id=1386a618&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386a618",
  null
  
)

export default component.exports